import { render, staticRenderFns } from "./CaseHistory.vue?vue&type=template&id=f57f10b4&scoped=true&"
import script from "./CaseHistory.vue?vue&type=script&lang=js&"
export * from "./CaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./CaseHistory.vue?vue&type=style&index=0&id=f57f10b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57f10b4",
  null
  
)

export default component.exports